import Fade from '@mui/material/Fade'
import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import { UserTick } from 'iconsax-react'
import ModalCloseButton from '../../Common/Modal/ModalCloseButton'
import { StyledModalIconWrapper } from '../../JobPost/style'
import Link from 'next/link'

type Props = {
  open: boolean
  onClose: () => void
}

const JoinUsModal: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme()

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: 'unset',
            borderRadius: '8px',
          },
        }}
      >
        <Fade in={true}>
          <Box>
            <DialogTitle
              sx={{
                paddingBottom: '4px',
                paddingTop: '40px',
                margin: '0 auto',
              }}
            >
              <Box sx={{ paddingX: '26px' }}>
                <Stack alignItems={'center'}>
                  <StyledModalIconWrapper>
                    <UserTick
                      size="56"
                      color={theme.palette.mediumGreen.main}
                    />
                  </StyledModalIconWrapper>
                </Stack>
              </Box>
            </DialogTitle>
            <ModalCloseButton onClick={onClose} />
            <DialogContent
              sx={{
                paddingX: { xs: '20px', md: '50px' },
                paddingY: '40px',
                paddingTop: '16px',
              }}
            >
              <Box
                sx={{
                  minWidth: { xs: '100%', md: '674px' },
                  maxWidth: { xs: '100%', md: '674px' },
                  textAlign: 'center',
                }}
              >
                <Typography variant="h5_xl" mt={1.25}>
                  Join Us?
                </Typography>

                <Typography variant="body_m_regular" mt={2.5}>
                  Signed up to be matched with the jobs that best suit you among
                  millions of job.
                </Typography>

                <Stack
                  direction={'row'}
                  mt={7.5}
                  spacing={1}
                  justifyContent={'center'}
                >
                  <Button variant="text" onClick={onClose}>
                    Keep Exploring
                  </Button>
                  <Link href={'/auth/register'}>
                    <Button onClick={() => {}}>Sign Up</Button>
                  </Link>
                </Stack>
              </Box>
            </DialogContent>
          </Box>
        </Fade>
      </Dialog>
    </>
  )
}

export default JoinUsModal
